import { render, staticRenderFns } from "./step3.vue?vue&type=template&id=de87a4f0&scoped=true&"
import script from "./step3.vue?vue&type=script&lang=js&"
export * from "./step3.vue?vue&type=script&lang=js&"
import style0 from "./step3.vue?vue&type=style&index=0&id=de87a4f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de87a4f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de87a4f0')) {
      api.createRecord('de87a4f0', component.options)
    } else {
      api.reload('de87a4f0', component.options)
    }
    module.hot.accept("./step3.vue?vue&type=template&id=de87a4f0&scoped=true&", function () {
      api.rerender('de87a4f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/market/activeXYFK/step3.vue"
export default component.exports